import { useEffect } from "react";
import { Button, CircularProgress } from "@mui/material";
import FileDownload from "@mui/icons-material/FileDownload";
import { useAlert } from "hooks/alerts/useAlert";
import useAssetExport from "hooks/assets/useAssetExport";
import { openDownload } from "utils/files";

export default function AssetsExportGridItem() {
  const { exportAssets, exportUrl, downloadAssetsExport, setDownloadAssetsExport, isExporting, isError } =
    useAssetExport();
  const { alertError } = useAlert();

  useEffect(() => {
    if (!isError || isExporting) return;

    alertError("There was an error exporting your assets. Please try again.");
  }, [isError, isExporting, alertError]);

  useEffect(() => {
    if (!downloadAssetsExport || !exportUrl) return;

    openDownload(exportUrl);
    setDownloadAssetsExport(false);
  }, [downloadAssetsExport, exportUrl, setDownloadAssetsExport]);

  return (
    <Button
      startIcon={isExporting ? <CircularProgress color="inherit" size={16} /> : <FileDownload />}
      size="small"
      disabled={isExporting}
      aria-busy={isExporting}
      sx={isExporting ? { "&.Mui-disabled": { color: "primary.main" } } : undefined}
      onClick={() => {
        exportAssets();
      }}
    >
      {isExporting ? "Exporting" : "Export"}
    </Button>
  );
}
